import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { DatabaseMetadataFieldFragmentDoc } from './DatabaseMetadataField';
export type DatabaseMetaDataFragment = { id: string, dbId: string, dbName: string, dbDefaultViewId: string, views?: Array<{ id: string, name: string, viewType: Types.ViewTypeEnum }> | null, fields: Array<{ name: string, type: Types.DatabaseFieldTypeEnum, fieldId: string, numberFormat?: Types.DatabaseNumberFormatEnum | null, dateFormat?: string | null, ratingType?: Types.DatabaseRatingTypeEnum | null, collectionType?: Types.DatabaseRelationCollectionTypeEnum | null, validation?: { maxValue?: number | null, maxLength?: number | null } | null, options?: Array<{ value: string, color: string, optionId: string }> | null }> };


export type DatabaseMetaDataFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const DatabaseMetaDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseMetaData on DatabaseMetadataType {
  id
  dbId
  dbName
  dbDefaultViewId
  views {
    id
    name
    viewType
  }
  fields {
    ...DatabaseMetadataField
  }
}
    `;